export default __webpack_public_path__ + "static/media/62_photo.7bc7172b.jpg";